export const typeRowStyles = {
  px: 1,
  my: 1,
  py: 0.5,
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'divider',
};

export const subtypeRowStyles = {
  alignItems: 'center',
  borderRadius: 2,
  '&:hover': {
    backgroundColor: 'grey.300',
  },
};

export const columnContentStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const firstColumnWidth = { xs: 4, md: 6 };

export const secondColumnWidth = { xs: 4, md: 3 };

export const thirdColumnWidth = { xs: 4, md: 3 };
